import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { MdModeEdit } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import * as apicall from "../../../components/Apicall";
import Loader from "../../../components/Loader/Loader";
import AddService from "../../Vendor_bookings/AddService";
import SlidePanel from "../../../components/SlidePanel/SlidePanel";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import AppDropdown from "../../../components/AppDropdown/AppDropdown";

const thStyle = {
  background: "#F9FAFB",
  fontWeight: 600,
  fontSize: "13px",
  color: "#374151",
  padding: "12px 16px",
  borderBottom: "1px solid #E5E7EB",
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: "12px 16px",
  fontSize: "14px",
  color: "#374151",
  borderBottom: "1px solid #F3F4F6",
  verticalAlign: "middle",
};

function CategoryRow({ item, index, onUpdate, onToggle }) {
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState(item.name);
  const [saving, setSaving] = useState(false);

  const handleEdit = async () => {
    try {
      setSaving(true);
      await apicall.post({ id: item.id, name }, "editService");
      setEditMode(false);
      onUpdate(item.id, name);
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <tr
      onMouseEnter={(e) => (e.currentTarget.style.background = "#F9FAFB")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      style={{ transition: "background 0.15s" }}
    >
      <td style={tdStyle}>{index + 1}</td>
      <td style={{ ...tdStyle, padding: "0 16px" }}>
        <div style={{ display: "flex", alignItems: "center", height: "56px" }}>
          {editMode ? (
            <div className="d-flex align-items-center gap-2" style={{ width: "100%" }}>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleEdit()}
                className="form-control"
                style={{ maxWidth: "220px" }}
                autoFocus
              />
              {saving ? (
                <Loader style={{ width: 30, height: 16 }} />
              ) : (
                <FaArrowRight
                  onClick={handleEdit}
                  style={{ cursor: "pointer", color: "#C0335A" }}
                />
              )}
            </div>
          ) : (
            item.name
          )}
        </div>
      </td>
      <td style={tdStyle}>
        <Form.Check
          type="switch"
          checked={item.is_active === 1}
          onChange={() => onToggle(item)}
          id={`cat-switch-${item.id}`}
        />
      </td>
      <td style={{ ...tdStyle, cursor: "pointer", color: "#C0335A" }}>
        <MdModeEdit size={17} onClick={() => setEditMode(!editMode)} />
      </td>
    </tr>
  );
}


function CategoriesTab({ label = "Category", onCategoryAdded }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState("all"); // "all" | "active" | "inactive"
const [selectedCategories, setSelectedCategories] = useState([]);
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [showDeletePanel, setShowDeletePanel] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [showInactivePanel, setShowInactivePanel] = useState(false);
  const [pendingToggle, setPendingToggle] = useState(null);
  const [confirmingInactive, setConfirmingInactive] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  async function fetchCategories() {
    try {
      setLoading(true);
      const res = await apicall.get("get_ezp_service");
      setCategories(res.success && res.data ? res.data : []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  const handleAddHide = (data) => {
    setShowAddPanel(false);
    if (data) {
      fetchCategories();
      if (onCategoryAdded) onCategoryAdded(data);
    }
  };

  const handleDelete = async () => {
    try {
      setDeleting(true);
      const res = await apicall.post({ id: selectedItem.id }, "delete_service");
      if (res?.success) {
        toast.success(res.message);
        fetchCategories();
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setDeleting(false);
      setShowDeletePanel(false);
      setSelectedItem(null);
    }
  };

  const handleToggle = async (item) => {
    const newStatus = item.is_active === 1 ? 0 : 1;

    if (newStatus === 0) {
      try {
        const checkRes = await apicall.post(
          { id: item.id, type: "service" },
          "check_active_status"
        );
        if (checkRes.hasBookings) {
          setPendingToggle({ item, count: checkRes.count });
          setShowInactivePanel(true);
          return;
        }
      } catch (e) {
        console.error(e);
      }
    }

    try {
      await apicall.post(
        { id: item.id, is_active: newStatus, type: "service" },
        "active_status"
      );
      setCategories((prev) =>
        prev.map((c) => (c.id === item.id ? { ...c, is_active: newStatus } : c))
      );
    } catch (e) {
      console.error(e);
    }
  };

  const confirmInactive = async () => {
    if (!pendingToggle) return;
    try {
      setConfirmingInactive(true);
      await apicall.post(
        { id: pendingToggle.item.id, is_active: 0, type: "service" },
        "active_status"
      );
      setCategories((prev) =>
        prev.map((c) => (c.id === pendingToggle.item.id ? { ...c, is_active: 0 } : c))
      );
    } catch (e) {
      console.error(e);
    } finally {
      setConfirmingInactive(false);
      setShowInactivePanel(false);
      setPendingToggle(null);
    }
  };

  // const filtered = categories.filter((c) => {
  //   const matchesSearch = c.name?.toLowerCase().includes(search.toLowerCase());
  //   const matchesActive =
  //     activeFilter === "all"
  //       ? true
  //       : activeFilter === "active"
  //       ? c.is_active === 1
  //       : c.is_active === 0;
  //   return matchesSearch && matchesActive;
  // });
const filtered = categories.filter((c) => {
  const matchesCategory =
    selectedCategories.length === 0 ||
    selectedCategories.some((item) => item.id === c.id);

  const matchesActive =
    activeFilter === "all"
      ? true
      : activeFilter === "active"
      ? Number(c.is_active) === 1
      : Number(c.is_active) === 0;

  return matchesCategory && matchesActive;
});
  return (
    <div>
      {/* Row 1: Title + action */}
      <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
        <div>
          <h5 className="mb-1 fw-bold" style={{ color: "#111827" }}>
            {label}
          </h5>
          <p className="mb-0" style={{ fontSize: "13px", color: "#6B7280" }}>
            Manage all {label.toLowerCase()} entries in your service catalog.
          </p>
        </div>
        <button
          onClick={() => setShowAddPanel(true)}
          className="btn btn-danger"
          style={{ borderRadius: "8px", fontSize: "13px", fontWeight: 600, height: "38px" }}
        >
          + Add {label}
        </button>
      </div>

      {/* Row 2: Search + Status filter */}
      <div className="d-flex gap-2 mb-3 align-items-center flex-wrap">
        <div style={{ position: "relative", flex: "1 1 200px", maxWidth: "320px" }}>
          <IoSearchOutline
            size={15}
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#9CA3AF",
              pointerEvents: "none",
            }}
          />
          {/* <input
            type="text"
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={`Search ${label.toLowerCase()}...`}
            style={{ paddingLeft: "32px", height: "38px", fontSize: "13px", borderRadius: "8px" }}
          /> */}
          <MultiSelect
  value={selectedCategories}
  onChange={(e) => setSelectedCategories(e.value)}
  options={categories}
  optionLabel="name"
  filter
  showClear
  placeholder={`Select ${label}`}
  maxSelectedLabels={3}
  style={{
    width: "320px",
    height: "38px",
  }}
/>
        </div>
        <AppDropdown
          value={activeFilter}
          options={[
            { label: "All", value: "all" },
            { label: "Active", value: "active" },
            { label: "Inactive", value: "inactive" },
          ]}
          onChange={e => setActiveFilter(e.value)}
          style={{ width: "140px", height: "38px", fontSize: "13px", flexShrink: 0 }}
        />
      </div>

      {/* Table */}
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}
      >
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["Sl. No", "Name", "Active", "Edit"].map((h) => (
                  <th key={h} style={thStyle}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(6)
                  .fill(null)
                  .map((_, i) => (
                    <tr key={i}>
                      <td style={tdStyle}><Skeleton width="30px" /></td>
                      <td style={tdStyle}><Skeleton width="160px" /></td>
                      <td style={tdStyle}><Skeleton width="40px" /></td>
                      <td style={tdStyle}><Skeleton width="24px" /></td>
                    </tr>
                  ))
              ) : filtered.length === 0 ? (
                <tr>
                  <td
                    colSpan={4}
                    style={{ ...tdStyle, textAlign: "center", color: "#6B7280", padding: "48px" }}
                  >
                    {search ? `No results for "${search}"` : `No ${label.toLowerCase()} entries found`}
                  </td>
                </tr>
              ) : (
                filtered.map((item, idx) => (
                  <CategoryRow
                    key={item.id}
                    item={item}
                    index={idx}
                    onUpdate={(id, newName) =>
                      setCategories((prev) =>
                        prev.map((c) =>
                          Number(c.id) === Number(id) ? { ...c, name: newName } : c
                        )
                      )
                    }
                    onToggle={handleToggle}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add SlidePanel */}
      <SlidePanel
        show={showAddPanel}
        onHide={() => handleAddHide(false)}
        title={`Add ${label}`}
      >
        <AddService onHideService={handleAddHide} />
      </SlidePanel>

      {/* Delete SlidePanel */}
      <SlidePanel
        show={showDeletePanel}
        onHide={() => { setShowDeletePanel(false); setSelectedItem(null); }}
        title={`Delete ${label}`}
      >
        <p style={{ fontSize: "15px", color: "#374151" }}>
          You are about to delete the {label.toLowerCase()}{" "}
          <strong>{selectedItem?.name}</strong>. This action cannot be undone.
          Are you sure you want to proceed?
        </p>
        <div className="d-flex gap-3 mt-4">
          <button
            onClick={() => { setShowDeletePanel(false); setSelectedItem(null); }}
            className="btn btn-outline-secondary px-4"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="btn Button primaryBackground text-white px-4"
            disabled={deleting}
          >
            {deleting ? <Loader style={{ width: 40, height: 20 }} /> : "Delete"}
          </button>
        </div>
      </SlidePanel>

      {/* Inactive Confirmation SlidePanel */}
      <SlidePanel
        show={showInactivePanel}
        onHide={() => { setShowInactivePanel(false); setPendingToggle(null); }}
        title={`Inactive ${label}`}
      >
        <p style={{ fontSize: "15px", color: "#374151" }}>
          There are <strong>{pendingToggle?.count}</strong> booking record(s) found for{" "}
          <strong>{pendingToggle?.item?.name}</strong>. If you inactive this{" "}
          {label.toLowerCase()}, those bookings will not be editable.
        </p>
        <div className="d-flex gap-3 mt-4">
          <button
            onClick={() => { setShowInactivePanel(false); setPendingToggle(null); }}
            className="btn btn-outline-secondary px-4"
          >
            Cancel
          </button>
          <button
            onClick={confirmInactive}
            className="btn Button primaryBackground text-white px-4"
            disabled={confirmingInactive}
          >
            {confirmingInactive ? <Loader style={{ width: 40, height: 20 }} /> : "Inactive"}
          </button>
        </div>
      </SlidePanel>
    </div>
  );
}

export default CategoriesTab;
